import { Icon } from '@iconify/react/dist/iconify.js';
import { FormControl, FormHelperText, FormLabel, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import * as React from 'react';


export default function CustomSelect({ values, variant, onChange, error, data, title, fullWidth, startAdornment, required, disabled, placeholder, subtitle, icon, name, valueName, labelName, width, height, marginTop = "0px", type, sx, ableClear = true, module, border, padding, isMobile = false, }) {
    return (
        <>
            <FormControl variant={variant ? variant : "standard"} fullWidth={fullWidth !== undefined ? fullWidth : (width ? false : true)} size="small" sx={{ marginTop: 1 }}>
                {/* {title && <InputLabel id="demo-simple-select-helper-label" style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{title} {isOptional ? <span className="optional-label">Optional</span> : null}</InputLabel>} */}
                <Select
                    value={values}
                    name={name}
                    required={required}
                    disabled={disabled}
                    displayEmpty
                    sx={sx && {
                        sx,
                    }}
                    labelId="demo-simple-select-helper-label"
                    label={title}
                    startAdornment={startAdornment}
                    disableUnderline={!variant || variant !== "standard"}
                    // renderValue={values !== "" ? undefined : () => disabled ? "" : placeholder}
                    renderValue={(selected) => (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: isMobile ? 1.4 : 1.2, gap: isMobile ? '2px' : '0px' }}>
                            <span style={{
                                fontSize: 12,
                                color: disabled ? '#C0C0C0' : '#808588',
                                fontWeight: 500,
                                marginBottom: 2
                            }}>
                                {/* {selected && selected !== '-1' && title} */}
                                {title}
                            </span>
                            <span style={{
                                fontSize: 14,
                                color: disabled ? '#C0C0C0' : (values === "" || values == "-1" || values == "inifinity" || values == "Infinity" || values === "NaN") ? "#BDBDBD" : 'inherit',
                                whiteSpace: isMobile ? 'normal' : 'nowrap'
                            }}>
                                {selected && (selected !== '-1' && selected !== "NaN" && selected !== "inifinity" && selected !== "Infinity") ? data?.find((item) => item[valueName || 'value'] === selected)?.[labelName || 'label'] :
                                    (String(placeholder || '').trim().toLowerCase() !== String(title || '').trim().toLowerCase()
                                        ? placeholder : "Please select")}
                            </span>
                        </div>
                    )}
                    onChange={(e) => onChange(e.target.value)}
                    style={{
                        color: (!values || values === "" || values == "-1" || values === "NaN" || values === "inifinity" || values === "Infinity") ? "#BDBDBD" : 'inherit',
                        width: width && width,
                        minHeight: height ? height : "56px",
                        marginTop: marginTop,
                        borderRadius: 12,
                        borderBottom: error ? "1px solid #BA2727" : "1px solid #D9D9D9",
                        border: border || '1.5px solid #E6E6E6',
                        paddingInline: 10,
                        backgroundColor: disabled ? "#f1f3f4" : "white",
                        paddingBlock: 0,
                        fontSize: 14
                    }}
                    inputProps={{ sx: { padding: padding || 1 } }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                borderRadius: 10,
                                maxHeight: 250, // limit the height of the dropdown
                            },
                        },
                    }}
                    IconComponent={() => (
                        ableClear ? (values == '-1' || !values) ? <i className="ri-arrow-down-s-line" style={{ color: '#1D1B1B' }}></i> : <i className="ri-close-line font-size-18" style={{ color: '#D9D9D9', cursor: disabled ? 'default' : 'pointer' }} onClick={() => disabled ? '' : onChange('')} /> : <Icon style={{ color: '#D9D9D9', fontSize: "12px" }} icon={"fluent:chevron-down-12-filled"} />
                    )}
                >
                    {/* <MenuItem style={{ display: "none" }} key={""} value="-1" disabled>{placeholder}</MenuItem>
                    <MenuItem style={{ display: "none" }} key={"all"} value="all" disabled>{placeholder}</MenuItem> */}
                    {
                        module &&
                        <MenuItem disabled value="">
                            {module}
                        </MenuItem>
                    }
                    {
                        data?.length > 0 ? data.map((x, idx) =>
                            <MenuItem key={idx}
                                value={x[`${valueName}`] || x?.value || x?.id}
                                style={{
                                    backgroundColor: (x[`${valueName}`] || x?.value || x?.id) === values ? '#FDECEC' : 'white',
                                    borderRadius: 10,
                                    margin: 5,
                                    color: (x[`${valueName}`] || x?.value || x?.id) === values ? '#1D1B1B' : '#1D1B1B'
                                }}
                            >
                                {
                                    icon ?
                                        <Typography><i className={`${x?.icon} p-2`}></i> {x[`${labelName}`] || x?.label || x?.name}</Typography>
                                        :
                                        (labelName && x[`${labelName}`]) || x?.label || x?.name
                                }
                            </MenuItem>
                        ) :
                            <MenuItem disabled>No options available</MenuItem>
                    }
                </Select>
                <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>
            </FormControl>
            {error && <FormHelperText className='d-flex align-items-center' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error || ""}</FormHelperText>}

        </>
    );
}
